module.exports = __webpack_public_path__ + "img/potus.c3aeacbd.gif";